
import enLogo1 from "../images/en/logo1.png"
import enLogo7 from "../images/en/logo7.png"
import enLogo8 from "../images/en/logo8.png"
import enLogo3 from "../images/en/logo3.png"
import enLogo6 from "../images/en/logo6.png"
import enLogo9 from "../images/en/logo9.png"
import enLogo12 from "../images/en/logo12.png"



import { UserLogoMapMobileType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapMobileType = {

    en: [enLogo1, enLogo7, enLogo8, enLogo3, enLogo6, enLogo9, enLogo12],
    em: [enLogo1, enLogo7, enLogo8, enLogo3, enLogo6, enLogo9, enLogo12],


};
